import match from 'lodash.ismatch';
import type { VariantAttribute } from 'types/variant';

export default function generateOptions(
    _attributes: VariantAttribute[],
    _selection: Record<string, string | number> = {},
    _order: {
        key: string;
        Label: string;
        Values: string[];
    }[],
    regenerate = false,
    prevOptions?: Record<string, Map<string, VariantAttribute[]>>,
): Map<string, Map<string, VariantAttribute[]>> {
    if (!_attributes?.length) return new Map();
    const attributeMap = new Map<string, Map<string, VariantAttribute[]>>();
    for (let i = 0; i < _attributes.length; i += 1) {
        const entry = _attributes[i];
        if (
            regenerate ||
            !Object.entries(_selection).length ||
            !Object.entries(entry.requirement).length ||
            match(entry.requirement, _selection) ||
            match(_selection, entry.requirement)
        ) {
            const attributes = attributeMap.get(entry.attribute);
            if (attributes) {
                if (attributes.has(entry.code)) {
                    const attribute = attributes.get(entry.code) ?? [];
                    attributes.set(entry.code, [...attribute, entry]);
                } else {
                    attributes.set(entry.code, [entry]);
                }
            } else {
                attributeMap.set(
                    entry.attribute,
                    new Map([[entry.code, [entry]]]),
                );
            }
        }
    }
    if (prevOptions) {
        Object.entries(prevOptions).forEach(([key, val]) =>
            attributeMap.set(key, val),
        );
    }

    // clear options if previous selection is unset
    for (let j = 0; j < _order.length; j += 1) {
        const curr = _order[j];
        if (curr?.key && !_selection[curr.key]) {
            const asd = _order[j + 1];
            if (asd?.key) {
                attributeMap.set(asd.key, new Map());
            }
        }
    }

    return attributeMap;
}
